<template>
  <div class="d-inline-block">
    <span ref="buttonRef" class="g-btn" />
  </div>
</template>

<script>
import { initGoogleApi } from '../../library/utils'
import { mapGetters } from 'vuex'

export default {
  props: {
    callback: { type: Function, required: true },
    isSignUp: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters(['ui']),
    configuration () {
      return {
        client_id: this.$googleClientId,
        callback: this.callback,
        itp_support: true
      }
    },
    buttonRef () {
      return this.$refs.buttonRef
    }
  },
  created() {
    // initialize Google API and render Sign in With Google button
    initGoogleApi().then(() => {
      this.renderButton()
    }).catch((error) => {
      console.error('failed to init google api', error)
      this.$store.dispatch('alert', {
        title: this.$t('SocialAccounts.initGoogleFailure'),
        body: error.data
      })
    })
  },
  methods: {
    renderButton () {
      /**
       * Render the Sign in With Google button
       * reference: https://developers.google.com/identity/gsi/web/guides/display-button#javascript
       */
      window.google.accounts.id.initialize(this.configuration)
      const button = this.buttonRef
      if (button) {
        window.google.accounts.id.renderButton(button, {
          theme: 'filled_blue',
          text: this.isSignUp ? 'signup_with' : 'signin_with',
          size: 'medium',
          locale: this.$i18n.locale
        })
      }
    }
  }
}
</script>
